import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { LoadingController, ModalController } from '@ionic/angular';
import { AttachmentService } from 'src/app/providers/forms/attachment/attachment.service';
import { UserDataService } from 'src/app/providers/userData/user-data.service';

@Component({
  selector: 'app-web-coordinator-section',
  standalone: false,
  templateUrl: './web-coordinator-section.component.html',
  styleUrls: ['./web-coordinator-section.component.scss'],
})
export class WebCoordinatorSectionComponent implements OnInit {

  @Input() formId;
  @Input() formTypeId;
  @Input() formStatus;
  @Input() webLinks;

  @Output() webCoordinatorUpdateEmitter: EventEmitter<any> = new EventEmitter<any>();

  sectionOpen = false;
  webCoordinatoLinkObject: any = {};
  isIQACADMIN: boolean = false;
  isWEBEQUI: boolean = false;
  isFROMIQACDASHBOARD:boolean = false
  isFROMOFFICEDASHBOARD:boolean = false
  isFROMOWEBDASHBOARD:boolean = false
  profile:any = {};
  subscriptionStatus:boolean = true;

  constructor(
    public modalController: ModalController,
    public userdataService: UserDataService,
    public attachementService: AttachmentService,
    public loadingController: LoadingController
  ) { }

  ngOnInit() {
    this.getProfile()
    this.initRoles();
    if (this.webLinks) {
      this.webLinks.forEach((link, index) => {
        if (index == 0) {
          this.webCoordinatoLinkObject.link1 = link;
        } else if (index == 1) {
          this.webCoordinatoLinkObject.link2 = link;
        } else if (index == 2) {
          this.webCoordinatoLinkObject.link3 = link;
        }
      });
    }
    this.userdataService.getCurrentActiveSection().then(section => {
      if (section) {
        if (section === 'IQAC_DASHBORAD') {
          this.isFROMIQACDASHBOARD = true;
        } else if(section === 'OFFICE_DASHBORAD') {
          this.isFROMOFFICEDASHBOARD = true;
        } else if (section === 'WEBC_DASHBORAD'){
          this.isFROMOWEBDASHBOARD = true;
        }
      }
    })
  }

  initRoles() {
    this.userdataService.getLoggedInUserRole().then(roles => {
      if (roles) {
        if (roles.includes("IQAC_ADMIN")) {
          this.isIQACADMIN = true;
        }
        if (roles.includes("WEB_EQUI")) {
          this.isWEBEQUI = true;
        }
      }
    });
  }

  canEditWebLinks() {
    let canEdit = false;
     if ((this.isWEBEQUI && !this.isFROMIQACDASHBOARD && this.isFROMOWEBDASHBOARD && 
      (this.formStatus === 'SHARED_WITH_WebC' 
      || this.formStatus === 'SHARED_WITH_WEB_AND_OFFICE'
      || this.formStatus === 'APPROVED_WITH_WebC' 
      || this.formStatus === 'APPROVED_WITH_WEB_AND_OFFICE'
      || this.formStatus === 'APPROVED_WITH_WebC_UPDATED' 
      || this.formStatus === 'APPROVED_WITH_WEB_AND_OFFICE_UPDATED' 
      || this.formStatus === 'APPROVED' 
      || this.formStatus === "APPROVED_WITH_BOTH_WebC_UPDATED" 
      || this.formStatus === 'APPROVED_WITH_BOTH_OFFICE_UPDATED'))) {
      canEdit = true
    }
    return canEdit;
  }

  updateLinks() {
    if (this.webCoordinatoLinkObject.link1 === undefined && this.webCoordinatoLinkObject.link2 === undefined && this.webCoordinatoLinkObject.link3 === undefined) {
      this.userdataService.presentToast('Kindly provide minimum 1 Web Link', 'danger');
      return;
    }
    this.addWeblinkToForm();
  }

  async addWeblinkToForm() {
    const loader = await this.loadingController.create({
      message: "Adding weblinks .."
    })
    loader.present();
    this.userdataService.getToken().then(token => {
      if (token) {
        let payload: any = {}
        payload.formTypeId = this.formTypeId;
        payload.formId = this.formId;

        let weblinksArray = []
        if (this.webCoordinatoLinkObject.link1 !== undefined) {
          weblinksArray.push(this.webCoordinatoLinkObject.link1);
        }
        if (this.webCoordinatoLinkObject.link2 !== undefined) {
          weblinksArray.push(this.webCoordinatoLinkObject.link2);
        }
        if (this.webCoordinatoLinkObject.link3 !== undefined) {
          weblinksArray.push(this.webCoordinatoLinkObject.link3);
        }
        payload.webLinks = weblinksArray;
        this.attachementService.addWeblinks(token, payload).subscribe(response => {
          if (response) {
            this.userdataService.presentToast('Form updated with Web Links Successfully.', 'success');
            this.webCoordinatorUpdateEmitter.emit(this.webCoordinatoLinkObject);
            loader.dismiss()
          }
        },error =>{
          console.log(error);
          loader.dismiss()
          this.userdataService.presentToast('Weblinks Updation Failed.', 'success');
        })
      }
    })
  }
  openLink(link) {
    window.open(link, '_blank');
  }

  getProfile()
    {
      this.userdataService.getUserProfile().then((profile) => {
        if (profile) {
          this.profile = profile;
          console.log("hibji :: "+this.profile)
          if(this.profile.college.status == "SUBS_EXPIRED")
          {
            this.subscriptionStatus = false;
          }
        }
      });
    }
}
